import { useEffect, useState } from 'react'
import useBriefContext from '../../../Hooks/Brief/useBriefContext'
import isBizBrief from '../../../Logic/Form/Sequences/Biz/isBizBrief'
import throwGQLError from '../../../Utilities/Urql/Errors/throwGQLError'
import { useGlobalAuth } from '@headbox-ui/auth-hook'
import { AccountType, UserResponseDto } from '@headbox-ui/auth-hook/dist/useGlobalAuth'
import getUserDetails from './getUserDetails'

interface UseRegisterUserArgs {
  skip: boolean
}
interface UseRegisterUser {
  registering: boolean
  registered: boolean
  user?: UserResponseDto
}

const useRegisterUser = ({ skip }: UseRegisterUserArgs): UseRegisterUser => {
  const { brief, dispatchBrief, setSubmitting, loading: authenticating } = useBriefContext()
  const { register, user, loading: registering, error } = useGlobalAuth()
  const [registered, setRegistered] = useState(false)

  useEffect(() => {
    if (skip || registered || registering) return

    // Block the Brief Provider from using its own loading state and refiring child CSS transitions
    setSubmitting(true)

    const isBizUser = isBizBrief(brief)
    const password = brief.guest?.password
    const userDetails = getUserDetails(brief)
    register(
      isBizUser ? AccountType.BUSINESS : AccountType.STANDARD,
      userDetails,
      isBizUser ? password : undefined
    )
  }, [skip])

  useEffect(() => {
    if (error === undefined) return

    throwGQLError(error)
  }, [error])

  useEffect(() => {
    if (!user) return

    dispatchBrief({
      updateAttributes: {
        userId: user.id,
        guest: { newlyRegistered: true, company: user.companyName, country: user.country },
      },
    })
    setRegistered(true)
  }, [user])

  useEffect(() => {
    if (!registered || registering || authenticating) return

    // Restore provider control of loading only after post-registration auth complete
    setSubmitting(false)
  }, [registering, registered, authenticating])

  return {
    registering,
    registered,
    user,
  }
}

export default useRegisterUser
